export default __webpack_public_path__ + "static/media/landing_image-01-01-01.70fdcf9a.svg";